import { Fragment } from 'react'

import { useTranslation } from 'react-i18next'

import { ListaProcuradores } from '@/features/proposta/brasil/components/lista-procuradores'
import type { TProcurador } from '@/features/proposta/brasil/types/compradores.types'
import type { TCompradoresCadastrados } from '@/features/proposta/brasil/types/proposta.type'
import {
  CardCompradorContent,
  CardCompradorInfo,
} from '@/features/proposta/shared/components/etapa-comprador/card-comprador'

interface IListaVinculosCompradorProps {
  vinculos?: TCompradoresCadastrados[0]['vinculos']
  obterProcuradoresDeCompradores: (vinculoId: string) => TProcurador[]
  onEdit: (cliente: TCompradoresCadastrados[0]['vinculos'][0] | TProcurador) => void
}

export const ListaVinculosComprador = ({
  vinculos,
  onEdit,
  obterProcuradoresDeCompradores,
}: IListaVinculosCompradorProps) => {
  const { t } = useTranslation('proposta')
  const text = {
    Conjuge: 'cadastro_compradores.tipo.conjuge',
    MaePai: 'cadastro_compradores.tipo.mae_pai',
    Representante: 'cadastro_compradores.tipo.representante',
  } as const

  if (!vinculos?.length) return null

  return vinculos.map((vinculo) => (
    <Fragment key={vinculo.id}>
      <CardCompradorContent onEdit={() => onEdit(vinculo)} className="border-t border-b-0">
        <CardCompradorInfo imagem={null} tipo={t(text[vinculo.tipo])} nome={vinculo.nome} />
      </CardCompradorContent>
      <ListaProcuradores onEdit={onEdit} procuradores={obterProcuradoresDeCompradores(vinculo.id)} />
    </Fragment>
  ))
}
